import { render, staticRenderFns } from "./HotelsMap.vue?vue&type=template&id=153ef634"
import script from "./HotelsMap.vue?vue&type=script&lang=js"
export * from "./HotelsMap.vue?vue&type=script&lang=js"
import style0 from "./HotelsMap.vue?vue&type=style&index=0&id=153ef634&prod&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports